var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 108,
    viewBox: "0 0 100 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_233_4482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.5423 104.186C5.44642 95.0154 -7.77012 59.1262 4.80135 34.8776C17.4388 10.4677 50.7037 12.5275 71.5804 28.1997C91.9733 44.0111 105.014 65.9874 97.8449 83.9393C90.9984 101.73 57.8801 113.568 31.5423 104.193V104.186Z",
    fill: "#CEEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9458 20.5086C102.007 14.9613 98.1666 6.97609 90.3685 2.67309C82.5704 -1.62991 73.7674 -0.621231 70.7064 4.92604C67.6454 10.4733 71.4856 18.4585 79.2837 22.7615C87.0818 27.0645 95.8848 26.0559 98.9458 20.5086Z",
    fill: "#CEEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9921 11.23H25.8173C22.8822 11.23 20.5029 13.6093 20.5029 16.5445V84.511C20.5029 87.4461 22.8822 89.8255 25.8173 89.8255H73.9921C76.9272 89.8255 79.3066 87.4461 79.3066 84.511V16.5445C79.3066 13.6093 76.9272 11.23 73.9921 11.23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9921 90.4779H25.8247C22.5334 90.4779 19.8578 87.8023 19.8578 84.511V16.5444C19.8578 13.2531 22.5334 10.5776 25.8247 10.5776H73.9921C77.2834 10.5776 79.959 13.2531 79.959 16.5444V84.511C79.959 87.8023 77.2834 90.4779 73.9921 90.4779ZM25.8247 11.8824C23.2517 11.8824 21.1553 13.9788 21.1553 16.5518V84.5183C21.1553 87.0913 23.2517 89.1877 25.8247 89.1877H73.9921C76.565 89.1877 78.6615 87.0913 78.6615 84.5183V16.5444C78.6615 13.9715 76.565 11.875 73.9921 11.875H25.8247V11.8824Z",
    fill: "#3A2382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7597 7.30096H41.057C39.3648 7.30096 37.993 8.67279 37.993 10.365V14.3381C37.993 16.0303 39.3648 17.4021 41.057 17.4021H58.7597C60.452 17.4021 61.8238 16.0303 61.8238 14.3381V10.365C61.8238 8.67279 60.452 7.30096 58.7597 7.30096Z",
    fill: "#3A2382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9154 27.1368H29.6291V34.4231H36.9154V27.1368Z",
    fill: "#3A2382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1877 28.3096H41.7387V29.6071H70.1877V28.3096Z",
    fill: "#3A2382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1877 31.9528H41.7387V33.2503H70.1877V31.9528Z",
    fill: "#3A2382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9154 40.8738H29.6291V48.1601H36.9154V40.8738Z",
    fill: "#3A2382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1877 42.0466H41.7387V43.3441H70.1877V42.0466Z",
    fill: "#3A2382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1877 45.6898H41.7387V46.9873H70.1877V45.6898Z",
    fill: "#3A2382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9154 54.6107H29.6291V61.897H36.9154V54.6107Z",
    fill: "#3A2382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1877 55.7836H41.7387V57.081H70.1877V55.7836Z",
    fill: "#3A2382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1877 59.4268H41.7387V60.7242H70.1877V59.4268Z",
    fill: "#3A2382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9154 68.3477H29.6291V75.634H36.9154V68.3477Z",
    fill: "#3A2382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1877 69.5206H41.7387V70.818H70.1877V69.5206Z",
    fill: "#3A2382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1877 73.1638H41.7387V74.4612H70.1877V73.1638Z",
    fill: "#3A2382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3939 11.8824H46.4228C45.3233 11.8824 44.429 10.9881 44.429 9.88856V4.52277C44.429 3.42323 45.3233 2.52893 46.4228 2.52893H53.3939C54.4935 2.52893 55.3878 3.42323 55.3878 4.52277V9.88856C55.3878 10.9881 54.4935 11.8824 53.3939 11.8824ZM46.4228 3.82639C46.0416 3.82639 45.7264 4.1416 45.7264 4.52277V9.88856C45.7264 10.2697 46.0416 10.5849 46.4228 10.5849H53.3939C53.7751 10.5849 54.0903 10.2697 54.0903 9.88856V4.52277C54.0903 4.13427 53.7751 3.82639 53.3939 3.82639H46.4228Z",
    fill: "#3A2382"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_233_4482"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 107.484,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIcon);
export default __webpack_public_path__ + "static/media/group-icon.dda6a092d404366abd30121cd03120a3.svg";
export { ForwardRef as ReactComponent };